import { render } from "./myDocuments.vue?vue&type=template&id=02c8546c&scoped=true&ts=true"
import script from "./myDocuments.vue?vue&type=script&lang=ts"
export * from "./myDocuments.vue?vue&type=script&lang=ts"

import "./myDocuments.vue?vue&type=style&index=0&id=02c8546c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c8546c"]])

export default __exports__